import { utils } from '@didi/webx-js'

export function rpx(rpx) {
  if (typeof rpx === 'number') {
    rpx = `${rpx}rpx`
  }
  const designWidth = 750
  let ratio = `${100 / designWidth}`
  let unit = 'vw'
  if (process.env.MODE === 'editor') {
    ratio = 0.5
    unit = 'px'
  }
  return rpx.replace(/(\d*\.?\d+)rpx([\s;,)}]|$)/g, function (...arg) {
    return `${arg[1] * ratio}${unit}${arg[2]}`
  })
}

const getStyleStrategy = [
  {
    test: (key, style) => typeof style[key] === 'number',
    handler: (key, style) => {
      style[key] = rpx(`${style[key]}rpx`)
    },
  },
  {
    test: (key, style) => {
      const isPic = /https:\/\/.*?(\.png|.jpe?g|\.webp)/.test(style[key])
      const needHandler = !/url\(.*?\)/.test(style[key])
      return isPic && needHandler
    },
    handler: (key, style) => {
      style[key] = `url('${utils.webpUrl(style[key])}')`
    },
  },
  {
    test: (key, style) => key === 'borderWidth',
    handler: (key, style) => {
      style.borderStyle = 'solid'
    },
  },
]

export function getStyle(style) {
  if (!style) return {}
  for (const key in style) {
    getStyleStrategy.forEach(strategy => {
      strategy.test(key, style) && strategy.handler(key, style)
    })
  }
  return style
}
